import XTbl, {Xtc} from '../../components/new-x-table/index';

const tbl = new XTbl('/job/table', '');
tbl.add(new Xtc('title', 'عنوان شغل').filterText());
tbl.add(new Xtc('cities_str_slot', 'شهر های فعال در شغل').renderSlot('cities_str_slot').filterText());
tbl.add(new Xtc('is_visible', 'نمایش در ثبت نام').renderSlot('visible').filterSwitch());
tbl.add(new Xtc('id', 'عملیات').renderSlot('operator'))
export default tbl;
